const COMMENT_HISTORY_KEY = 'task_comment_history';
const MAX_COMMENTS = 5;

export const getStoredComments = () => {
  try {
    return JSON.parse(localStorage.getItem(COMMENT_HISTORY_KEY)) || [];
  } catch {
    return [];
  }
};

export const storeComment = (text) => {
  if (!text?.trim()) return;

  const existing = getStoredComments();

  if (existing.includes(text)) {
    localStorage.setItem(
      COMMENT_HISTORY_KEY,
      JSON.stringify([text, ...existing.filter((c) => c !== text)])
    );
    return;
  }

  if (existing.length >= MAX_COMMENTS) return;

  localStorage.setItem(
    COMMENT_HISTORY_KEY,
    JSON.stringify([text, ...existing])
  );
};

export const removeStoredComment = (text) => {
  localStorage.setItem(
    COMMENT_HISTORY_KEY,
    JSON.stringify(getStoredComments().filter((c) => c !== text))
  );
};
